import Marquee from "react-fast-marquee";
import { useI18n } from "../i18n";

const PARTNERS = [
  "Планета КВН",
  "АМИК",
  "Первый канал",
  "ТНТ",
  "НТК",
  "VK Видео",
  "Хабар",
  "Media Quality",
  "BAS Production",
  "WE Project",
  "Игра",
  "Звёзды",
  "Comedy Club",
  "Однажды в России",
  "Stand Up Astana",
  "Apex Event Group",
  "Stand-up Atlanta",
];

const Partners = () => {
  const { lang } = useI18n();
  return (
    <section
      id="partners"
      data-testid="partners-section"
      className="relative py-14 md:py-16 border-t border-white/10 bg-[#0a0205]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 mb-6 md:mb-8">
        <div className="flex items-center gap-4">
          <span className="kicker !mb-0 !text-white/45 [&::before]:!bg-white/25">
            {lang === "ru" ? "ПРОЕКТЫ И ПАРТНЁРЫ" : "PROJECTS & PARTNERS"}
          </span>
          <span className="divider-line flex-1" />
          <span className="text-[11px] tracking-widest uppercase text-white/35 font-semibold">
            {PARTNERS.length}+
          </span>
        </div>
        <p className="mt-3 text-white/55 text-sm max-w-2xl">
          {lang === "ru"
            ? "Проекты, в которых участвовала команда, и партнёры, поддерживающие гастроли Team Astana."
            : "Projects Team Astana has been part of and partners powering the world tour."}
        </p>
      </div>

      {/* Edge fade overlays */}
      <div className="relative">
        <div
          aria-hidden
          className="absolute left-0 top-0 bottom-0 w-24 md:w-40 z-10 pointer-events-none"
          style={{
            background: "linear-gradient(to right, #0a0205 0%, transparent 100%)",
          }}
        />
        <div
          aria-hidden
          className="absolute right-0 top-0 bottom-0 w-24 md:w-40 z-10 pointer-events-none"
          style={{
            background: "linear-gradient(to left, #0a0205 0%, transparent 100%)",
          }}
        />

        <Marquee speed={45} gradient={false} pauseOnHover>
          {PARTNERS.map((p, i) => (
            <div
              key={`a-${i}`}
              className="mx-3 md:mx-4 my-1 inline-flex items-center gap-3 px-5 md:px-6 py-3 md:py-4 border border-white/15 bg-black/40 hover:border-[#FFDE00]/70 hover:bg-black/70 transition-colors"
              data-testid={`partner-${i}`}
            >
              <span className="w-1.5 h-1.5 bg-[#FFDE00] rounded-full" />
              <span className="font-display text-xl md:text-2xl tracking-tight text-white/85 whitespace-nowrap">
                {p}
              </span>
            </div>
          ))}
        </Marquee>

        <Marquee speed={35} gradient={false} pauseOnHover direction="right" className="mt-3 md:mt-4">
          {PARTNERS.slice().reverse().map((p, i) => (
            <div
              key={`b-${i}`}
              className="mx-3 md:mx-4 my-1 inline-flex items-center gap-3 px-5 md:px-6 py-3 md:py-4 border border-white/10 bg-black/30 hover:border-[#FFDE00]/60 hover:bg-black/60 transition-colors"
              data-testid={`partner-r-${i}`}
            >
              <span className="text-[#FFDE00] text-xs">★</span>
              <span className="font-display text-lg md:text-xl tracking-tight text-white/65 whitespace-nowrap">
                {p}
              </span>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default Partners;
